export default __webpack_public_path__ + "static/media/Highlord's Mark of Abhorrence.ac61cb44.jpg";